import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import useAddSeats from "api/SubscriptionsResource/useAddSeats";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { activePaymentMethods, activeCurrencies } from "utils";

const EcocashPaymentZwl = ({
	subscriptionId,
	additionalSeats,
	totalAmount,
	onSuccess,
	currency,
}) => {
	const { mutateAsync: addSeats, isLoading } = useAddSeats(subscriptionId, onSuccess);

	const formik = useFormik({
		initialValues: {
			phone: "",
		},
		validationSchema: Yup.object({
			phone: Yup.string()
				.matches(/^263[0-9]{9}$/, "Phone number must be in format 263XXXXXXXXX")
				.required("Phone number is required"),
		}),
		onSubmit: async (values) => {
			await addSeats({
				additional_seats: additionalSeats,
				payment_method: activePaymentMethods.ecocashZwl.name,
				currency: currency || activeCurrencies.ZWL.code,
				total_amount: totalAmount,
				phone: values.phone,
			});
		},
	});

	return (
		<form onSubmit={formik.handleSubmit} className="space-y-4">
			<div className="bg-green-50 border-l-4 border-green-500 p-4">
				<p className="text-green-700 text-sm">
					<strong>Total to pay:</strong> {activeCurrencies.ZWL.symbol} {totalAmount.toFixed(2)} for{" "}
					{additionalSeats} additional seat(s)
				</p>
			</div>

			<div>
				<label className="block text-sm font-medium text-gray-700 mb-2">EcoCash Phone Number</label>
				<input
					type="text"
					name="phone"
					placeholder="263XXXXXXXXX"
					value={formik.values.phone}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
					className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-akgreen focus:border-transparent"
				/>
				{formik.errors.phone && formik.touched.phone && (
					<p className="mt-1 text-sm text-red-600">{formik.errors.phone}</p>
				)}
			</div>

			<button
				type="submit"
				disabled={isLoading}
				className="w-full px-6 py-3 bg-gradient-to-r from-green-600 to-green-700 text-white font-semibold rounded-lg hover:shadow-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
			>
				{isLoading ? (
					<>
						<AiOutlineLoading3Quarters className="animate-spin" size={20} />
						Processing...
					</>
				) : (
					"Pay with EcoCash ZWL"
				)}
			</button>
		</form>
	);
};

export default EcocashPaymentZwl;
